import React from "react";
import { Row, Col } from "reactstrap";
import "./stats.scss";
class Stats extends React.Component {
  render() {
    return (
      <div className="stats-container">
        <Row className="m-0 p-0">
          <Col lg="3" xs="6" sm="6" md="6" className="m-0 p-0 text-left">
            <div className="stats-card">
              <img
                className="icon"
                src={require("../../../assets/images/icons/people.png")}
                alt=""
              />
              <h2 className="title">2 Lac+</h2>
              <h2 className="sub-title opacity-70">People Insured</h2>
            </div>
          </Col>
          <Col lg="3" xs="6" sm="6" md="6" className="m-0 p-0 text-left">
            <div className="stats-card">
              <img
                className="icon"
                src={require("../../../assets/images/icons/claim.png")}
                alt=""
              />
              <h2 className="title">99.1%</h2>
              <h2 className="sub-title opacity-70">Claims Ratio</h2>
            </div>
          </Col>
          <Col lg="3" xs="6" sm="6" md="6" className="m-0 p-0 text-left">
            <div className="stats-card">
              <img
                className="icon"
                src={require("../../../assets/images/icons/time.png")}
                alt=""
              />
              <h2 className="title">3 Days</h2>
              <h2 className="sub-title opacity-70">To Settle claims</h2>
            </div>
          </Col>
          <Col lg="3" xs="6" sm="6" md="6" className="m-0 p-0 text-left">
            <div className="stats-card">
              <img
                className="icon"
                src={require("../../../assets/images/icons/pin.png")}
                alt=""
              />
              <h2 className="title">170+</h2>
              <h2 className="sub-title opacity-70">Cities Covered</h2>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Stats;
